import React, { Component } from 'react';

import { connect } from "react-redux";

import Confetti from "./Confetti";

import AccAccessBtnContainer from '../../../containers/AccAccessBtnContainer';

import {numberWithCommas} from './../../../utils/utils';

import {saveHighScoreToGSNTV, saveUserDataToGSNTV, userDataFromGSNTV} from './../../../utils/gsntv';

//import {setMaxScore} from './../../../actions';

import './../../../../scss/App.scss';
import { trackingWrapper } from '../../../utils/analytics';
import FooterLogo from '../../FooterLogo';



class BonusResultsOverlay extends Component {
	constructor(props){
		super(props);

		this.transitionIn = new window.TimelineMax({onComplete : this.handleTransitionComplete,
									onCompleteParams:[this],
									onReverseComplete:this.handleTransitionOutComplete, 
									onReverseCompleteParams:[this]});

		this.accAccessBtn = React.createRef();
	}

	componentDidMount(){

		// stop all bg
		window.sounds.introBg.stop();
		window.sounds.roundBg.stop();
		window.sounds.bonusBg.stop();
		window.sounds.gameOverBg.stop();

		// play bg music
		window.sounds.gameOverBg.play();
		window.sounds.gameOverBg.volume(.3);


		// update user's score if logged in
		console.log("======= BonusResultsOverlay :: componentDidMount");
		console.log("BonusResultsOverlay :: componentDidMount - this.props.userLoggedIn : ", this.props.userLoggedIn);
		//console.log("BonusResultsOverlay :: componentDidMount - this.props.maxScore : ", this.props.maxScore);
		console.log("BonusResultsOverlay :: componentDidMount - this.props.user : ", this.props.user);

		if(this.props.userLoggedIn){
			this.saveScore();
		}


		// animate in

		window.TweenMax.set(this.refs.overlay, {"opacity": 0});
		window.TweenMax.set(this.refs.logo, {"opacity": 0, "transform":"translateY(1vw)"});
		window.TweenMax.set(this.refs.tuneIn, {"opacity": 0, "transform":"translateY(1vw)"});
		window.TweenMax.set(this.refs.host, {"height": "0%"});
		window.TweenMax.set(this.refs.line1, {"opacity": 0, "transform":"translateY(1vw)"});
		window.TweenMax.set(this.refs.line2, {"opacity": 0, "transform":"translateY(1vw)"});
		window.TweenMax.set(this.refs.line3, {"opacity": 0, "transform":"translateY(1vw)"});
		window.TweenMax.set(this.refs.playAgainBtn, {"opacity": 0, "transform":"translateY(1vw)"});
		window.TweenMax.set(this.accAccessBtn.current, {"opacity": 0, "transform":"translateY(1vw)"});
		window.TweenMax.set(this.refs.leaderboardBtn, {"opacity": 0, "transform":"translateY(1vw)"});


		this.transitionIn.to(this.refs.overlay, .5, {"opacity":1, "delay":.3})
		.to(this.refs.logo, .4, {"opacity":1, "transform":"translateY(0vw)"}, "-=.3")
		.to(this.refs.tuneIn, .4, {"opacity":1, "transform":"translateY(0vw)"}, "-=.3")
		.to(this.refs.host, .4, {"height": "100%"}, "-=.3")
		.to(this.refs.line1, .4, {"opacity":1, "transform":"translateY(0vw)"}, "-=.6")
		.to(this.refs.line2, .4, {"opacity":1, "transform":"translateY(0vw)"}, "-=.3")
		.to(this.refs.line3, .4, {"opacity":1, "transform":"translateY(0vw)"}, "-=.3")
		.to(this.refs.playAgainBtn, .4, {"opacity":1, "transform":"translateY(0vw)"}, "-=.3")
		.to(this.accAccessBtn.current, .4, {"opacity":1, "transform":"translateY(0vw)"}, "-=.3")
		.to(this.refs.leaderboardBtn, .4, {"opacity":1, "transform":"translateY(0vw)"}, "-=.3");

		// tracking
		trackingWrapper('event', 'ASgame-end', {'event_label':this.props.totalPoints,'event_category':'america-says-game'});

		// gleam
		var Gleam = window.Gleam || [];
		Gleam.push(['america-says-game-daily-play-holiday-regular', 'myValue']);
	}

	componentDidUpdate(prevProps, prevState) {
		console.log('*********** BonusResultsOverlay :: componentDidUpdate');
		if (prevProps.userLoggedIn !== this.props.userLoggedIn && this.props.userLoggedIn === true) {
			console.log('*********** BonusResultsOverlay :: componentDidUpdate - will save score');
			this.saveScore();
		}
	}

	saveScore() {
		console.log('-------- BonusResultsOverlay :: saveScore - this.props.totalPoints', this.props.totalPoints);
		//console.log('-------- BonusResultsOverlay :: saveScore - this.props.maxScore', this.props.maxScore);

		userDataFromGSNTV().then((data) => {
			const userJSON = JSON.parse(data);
			
			console.log('-------- BonusResultsOverlay :: saveScore - userDataFromGSNTV data', data);
			console.log('-------- BonusResultsOverlay :: saveScore - userDataFromGSNTV userJSON.maxScore', userJSON.maxScore);

			if( (this.props.totalPoints > userJSON.maxScore) || userJSON.maxScore === null || userJSON === false){
				
				console.log("BonusResultsOverlay :: saveScore - this.props.user : ", this.props.user);

				const leaderboardUpdateObj = {
					"name" : ( this.props.user.firstName + " " + this.props.user.lastName.charAt(0) + "." ),
					"highScore" : this.props.totalPoints
				};

				console.log("BonusResultsOverlay :: saveScore - leaderboardUpdateObj : ", leaderboardUpdateObj);

				// save to leaderboard
				saveHighScoreToGSNTV(leaderboardUpdateObj);

				// save to user profile
				const scoreObj = JSON.stringify({
					"maxScore" : this.props.totalPoints
				});

				saveUserDataToGSNTV(scoreObj).then(() => {
					userDataFromGSNTV().then((data) => {
						console.log("!!! save user data - new data: ", data);
					});
				});

				// store in redux
				//this.props.store.dispatch(setMaxScore(this.props.totalPoints));
			}
			else {
				console.log("BonusResultsOverlay :: saveScore - score not high enough to be saved");
			}
		});
	}

	handleTransitionComplete(_this){

	}

	handleTransitionOutComplete(_this){
		//_this.props.initRound();
	}

	facebookHandleClick(){
		trackingWrapper('event', 'ASgame-share-fb', {'event_category':'america-says-game', 'event_label':'result'});
	}

	twitterHandleClick(){
		trackingWrapper('event', 'ASgame-share-tw', {'event_category':'america-says-game', 'event_label':'result'});
	}

	handlePlayBtnClick(){
		//this.transitionIn.reverse();
	}

	renderConfetti(){
		if(this.props.hasReachedBonusRound){
			return(
				<Confetti />
			);
		}
	}

	render(){
		const { 
			affiliate,
			isAppIframed
		} = this.props;
		const btnRef = this.accAccessBtn;
		const btnClassName = {
			login: 'loginBtn button' + (isAppIframed ? '': ' hide'),
			logout: 'loginBtn button' + (isAppIframed ? '': ' hide'),
		}

		const btnLabel = {
			login: 'Login / Register',
			logout: 'Logout',
		}

		//

		var line1Msg = "THANK YOU FOR PLAYING!";

		if(this.props.hasReachedBonusRound){
			line1Msg = "CONGRATULATIONS!";
		}

		return(
			<div className="bonusResults_overlay" ref="overlay">
				<div className="content" ref="content">
					<div className="leftColumn">
						<div className="logo" ref="logo"><span>Weekdays</span></div>
						{affiliate!==null &&
							<img className="affiliateLogo" src={"images/" + affiliate.imgName } />
						}
						<div className="tuneIn" ref="tuneIn"></div>
						<div className="host" ref="host"></div>
						{window.config.share &&
						<div className="socialWrapper">
							<div className="label">Share Your Score!</div>
				 			<div className="fab fa-facebook-square" onMouseOver={() => window.sounds.buttonHover.play()} onClick={() => this.facebookHandleClick()}></div>
				 			<div className="fab fa-twitter-square" onMouseOver={() => window.sounds.buttonHover.play()} onClick={() => this.twitterHandleClick()}></div>
						</div>
						}
					</div>
					<div className="rightColumn">
						<div className="line1" ref="line1">{line1Msg}</div>
						<div className="line2" ref="line2">Your Final Score Is:<br/>{numberWithCommas(this.props.totalPoints)} points</div>
						<div className="line3" ref="line3">Think you can do better?</div>
						<div className="buttonsWrapper">
							<div className="playAgainBtn button" ref="playAgainBtn" onMouseOver={() => window.sounds.buttonHover.play()} onClick={() => this.props.handlePlayAgainBtn()}>Play Again</div>
							{/*<div className="loginBtn button" ref="loginBtn" onMouseOver={() => window.sounds.buttonHover.play()} onClick={() => this.props.handleLoginBtn()}>Login / Register</div>*/}
							<AccAccessBtnContainer 
								btnLabel = {btnLabel} 
								btnRef = {btnRef} 
								btnClassName = {btnClassName}
								/>
							<div className="leaderboardBtn button" ref="leaderboardBtn" onMouseOver={() => window.sounds.buttonHover.play()} onClick={() => this.props.handleLeaderboardBtn()}>{window.config.buttons.leaderboard.label}</div>
						</div>
					</div>
					<FooterLogo />
				</div>
				{this.renderConfetti()}
			</div>
		);
	}
}


const mapStateToProps = state => ({
  userLoggedIn: state.userLoggedIn,
  isAppIframed: state.isAppIframed,
  maxScore: state.maxScore, 
	user: state.user,
	affiliate: state.affiliate
});

export default connect(
  mapStateToProps
)(BonusResultsOverlay);





// WEBPACK FOOTER //
// ./src/js/components/gamepage/results/BonusResultsOverlay.js